{
  "regexMatch": {
    "exemplo": "regexMatch({@TEXTO},\"[0-9]+\")",
    "variaveis": [
      {
        "key": "@TEXTO",
        "value": "pedido a1b2c3",
        "type": "TEXTO"
      }
    ],
    "runnable": true,
    "retorna": "texto",
    "combina": "retorna o primeiro trecho que casa (grupo 0); entra em qualquer arg de texto, bom pra extrair codigo/numero solto. Pattern com parenteses use balanceado inline ou via {@VAR}.",
    "cat": "regex",
    "validado": true,
    "resultado": "1"
  },
  "regexExtract": {
    "exemplo": "regexExtract(\"pedido 4821 ok\",\"([0-9]+)\",\"1\")",
    "variaveis": [],
    "runnable": true,
    "retorna": "texto",
    "combina": "retorna o grupo de captura informado (groupIndex \"0\" = match inteiro); aninha bem como arg de findJSON/concatenar pra isolar parte de um identificador.",
    "cat": "regex",
    "validado": true,
    "resultado": "4821"
  },
  "regexReplace": {
    "exemplo": "regexReplace(\"2026-06-04\",\"([0-9]{4})-([0-9]{2})-([0-9]{2})\",\"$3/$2/$1\")",
    "variaveis": [],
    "runnable": true,
    "retorna": "texto",
    "combina": "substitui TODOS os matches e suporta backref $1/$2; entra em qualquer arg de texto, util pra reformatar data/mascara antes de gravar.",
    "cat": "regex",
    "validado": true,
    "resultado": "04/06/2026"
  },
  "regexTest": {
    "exemplo": "regexTest(\"abc123\",\"[0-9]+\")",
    "variaveis": [],
    "runnable": true,
    "retorna": "booleano",
    "combina": "retorna true/false; usar como condicao dentro de ifThenElse/dataSwitch pra validar formato antes de prosseguir.",
    "cat": "regex",
    "validado": true,
    "resultado": "true"
  },
  "subtract": {
    "exemplo": "subtract({@VALOR_BRUTO},{@DESCONTO})",
    "variaveis": [
      {
        "key": "@VALOR_BRUTO",
        "value": "150.00",
        "type": "TEXTO"
      },
      {
        "key": "@DESCONTO",
        "value": "12.50",
        "type": "TEXTO"
      }
    ],
    "runnable": true,
    "retorna": "numero",
    "combina": "BigDecimal puro; entra em qualquer arg de texto e aninha bem com add/multiply/roundValue (ex.: roundValue(subtract(...),2))",
    "cat": "math",
    "validado": true,
    "resultado": "137.50"
  },
  "multiply": {
    "exemplo": "multiply({@QTD},{@PRECO_UNIT})",
    "variaveis": [
      {
        "key": "@QTD",
        "value": "3",
        "type": "TEXTO"
      },
      {
        "key": "@PRECO_UNIT",
        "value": "29.90",
        "type": "TEXTO"
      }
    ],
    "runnable": true,
    "retorna": "numero",
    "combina": "BigDecimal puro; aninha bem dentro de add/roundValue para totalizar item (ex.: roundValue(multiply(...),2))",
    "cat": "math",
    "validado": true,
    "resultado": "89.70"
  },
  "roundValue": {
    "exemplo": "roundValue(divide({@TOTAL},{@PARCELAS}),2)",
    "variaveis": [
      {
        "key": "@TOTAL",
        "value": "100.00",
        "type": "TEXTO"
      },
      {
        "key": "@PARCELAS",
        "value": "3",
        "type": "TEXTO"
      }
    ],
    "runnable": true,
    "retorna": "numero",
    "combina": "fecha o pipeline: envolve add/subtract/multiply/divide para fixar casas decimais (scale e o numero de decimais)",
    "cat": "math",
    "validado": true,
    "resultado": "33.33"
  },
  "add": {
    "exemplo": "add({@FRETE},{@SEGURO})",
    "variaveis": [
      {
        "key": "@FRETE",
        "value": "18.90",
        "type": "TEXTO"
      },
      {
        "key": "@SEGURO",
        "value": "4.10",
        "type": "TEXTO"
      }
    ],
    "runnable": true,
    "retorna": "numero",
    "combina": "BigDecimal puro; aceita resultado de multiply/subtract em cada arg e o total cabe num findJSON/concatenar",
    "cat": "math",
    "validado": true,
    "resultado": "23.00"
  },
  "divide": {
    "exemplo": "roundValue(divide({@TOTAL_PEDIDO},{@QTD_ITENS}),2)",
    "variaveis": [
      {
        "key": "@TOTAL_PEDIDO",
        "value": "250.00",
        "type": "TEXTO"
      },
      {
        "key": "@QTD_ITENS",
        "value": "4",
        "type": "TEXTO"
      }
    ],
    "runnable": true,
    "retorna": "numero",
    "combina": "use sempre dentro de roundValue (dizimas geram muitas casas pelo MATH_CTX); divisor zero lanca erro",
    "cat": "math",
    "validado": true,
    "resultado": "62.50"
  },
  "formatString": {
    "exemplo": "formatString(\"12345678901\",\"###.###.###-##\")",
    "variaveis": [],
    "runnable": true,
    "retorna": "texto",
    "combina": "entra em qualquer arg de texto; use pra mascarar CPF/CNPJ/CEP. Retorna \"0\" se o valor nao bate na mascara",
    "cat": "texto",
    "validado": true,
    "resultado": "123.456.789-01"
  },
  "extract": {
    "exemplo": "extract({@SKU},1,3)",
    "variaveis": [
      {
        "key": "@SKU",
        "value": "ABC-998877",
        "type": "TEXTO"
      }
    ],
    "runnable": true,
    "retorna": "texto",
    "combina": "substring seguro 1-based (start inicia em 1, end exclusivo); aninha bem dentro de toUpperCase/concatenar; nao estoura em indice fora do tamanho",
    "cat": "texto",
    "validado": true,
    "resultado": "ABC"
  },
  "encodeString": {
    "exemplo": "encodeString(\"Camiseta P&M <Promoção>\")",
    "variaveis": [],
    "runnable": true,
    "retorna": "texto",
    "combina": "codifica HTML entities; use antes de montar payload XML/HTML de marketplace, dentro de concatenar",
    "cat": "texto",
    "validado": true,
    "resultado": "Camiseta%20P%26M%20%3CPromo%C3%A7%C3%A3o%3E"
  },
  "replaceDoubleQuote": {
    "exemplo": "replaceDoubleQuote({@DESC},\"\")",
    "variaveis": [
      {
        "key": "@DESC",
        "value": "Tenis \"esportivo\" unissex",
        "type": "TEXTO"
      }
    ],
    "runnable": true,
    "retorna": "texto",
    "combina": "troca aspas duplas pelo 2o arg; use antes de injetar texto livre em JSON/CSV pra nao quebrar a string",
    "cat": "texto",
    "validado": true,
    "resultado": "Tenis esportivo unissex"
  },
  "removerCaracteresEspeciais": {
    "exemplo": "removerCaracteresEspeciais(\"Caçá#@!ção/ç\")",
    "variaveis": [],
    "runnable": true,
    "retorna": "texto",
    "combina": "limpa caracteres especiais; encaixa em qualquer arg de texto antes de gravar em campo restrito do ERP",
    "cat": "texto",
    "validado": true,
    "resultado": "Caçá#@!ção/ç"
  },
  "onlyAlpha": {
    "exemplo": "onlyAlpha(\"Produto 123 XYZ\")",
    "variaveis": [],
    "runnable": true,
    "retorna": "texto",
    "combina": "mantem so letras (overload c/ 2o arg troca o resto pelo char dado); aninha em toUpperCase/trim",
    "cat": "texto",
    "validado": true,
    "resultado": "Produto  XYZ"
  },
  "secureSubstring": {
    "exemplo": "secureSubstring({@CODIGO},0,4)",
    "variaveis": [
      {
        "key": "@CODIGO",
        "value": "BR2026PEDIDO",
        "type": "TEXTO"
      }
    ],
    "runnable": true,
    "retorna": "texto",
    "combina": "substring 0-based (start inicia em 0, end exclusivo) que nao estoura; difere de extract que e 1-based; bom pra fatiar prefixo de codigo",
    "cat": "texto",
    "validado": true,
    "resultado": "BR20"
  },
  "replaceQuote": {
    "exemplo": "replaceQuote({@NOME},\"\")",
    "variaveis": [
      {
        "key": "@NOME",
        "value": "Tênis O'Neill",
        "type": "TEXTO"
      }
    ],
    "runnable": true,
    "retorna": "texto",
    "combina": "troca aspas simples pelo 2o arg; use antes de montar SQL/JSON com texto livre",
    "cat": "texto",
    "validado": true,
    "resultado": "Tênis ONeill"
  },
  "onlyAlphaNumbers": {
    "exemplo": "onlyAlphaNumbers(\"NF-e 123/45 #ABC\")",
    "variaveis": [],
    "runnable": true,
    "retorna": "texto",
    "combina": "mantem letras e numeros (overload c/ 2o arg troca o resto pelo char dado); entra em qualquer arg de texto",
    "cat": "texto",
    "validado": true,
    "resultado": "NFe12345ABC"
  },
  "onlyNumbers": {
    "exemplo": "onlyNumbers({@CNPJ})",
    "variaveis": [
      {
        "key": "@CNPJ",
        "value": "12.345.678/0001-99",
        "type": "TEXTO"
      }
    ],
    "runnable": true,
    "retorna": "texto",
    "combina": "remove tudo que nao e digito; combina com leftPad pra normalizar CNPJ/CEP, ou com formatString depois",
    "cat": "texto",
    "validado": true,
    "resultado": "12345678000199"
  },
  "concatenar2": {
    "exemplo": "concatenar2(\"PED-\",{@NUMERO},\"-\",{@UF})",
    "variaveis": [
      {
        "key": "@NUMERO",
        "value": "998877",
        "type": "TEXTO"
      },
      {
        "key": "@UF",
        "value": "SP",
        "type": "TEXTO"
      }
    ],
    "runnable": true,
    "retorna": "texto",
    "combina": "concatena N args separados por virgula (use *SPACE* pra inserir espaco); aninha resultados de extract/onlyNumbers",
    "cat": "texto",
    "validado": true,
    "resultado": "PED-998877-SP"
  },
  "html2text": {
    "exemplo": "html2text(\"<p>Descrição do <b>produto</b></p>\")",
    "variaveis": [],
    "runnable": true,
    "retorna": "texto",
    "combina": "extrai texto puro de HTML; use na descricao vinda do marketplace antes de gravar no ERP",
    "cat": "texto",
    "validado": true,
    "resultado": "Descrição do produto"
  },
  "replaceComment": {
    "exemplo": "replaceComment(\"SELECT 1 /*OBS dado interno OBS*/\",\"OBS\")",
    "variaveis": [],
    "runnable": true,
    "retorna": "texto",
    "combina": "remove blocos /*comment ... comment*/ pelo marcador dado; nicho, entra em qualquer arg de texto",
    "cat": "texto",
    "validado": true,
    "resultado": "SELECT 1   dado interno  "
  },
  "splitString": {
    "exemplo": "splitString(\"SP;RJ;MG\",\";\",2)",
    "variaveis": [],
    "runnable": true,
    "retorna": "texto",
    "combina": "pega a posicao 1-based apos split (overload de 2 args usa virgula fixa); se o indice estoura, devolve o ultimo item",
    "cat": "texto",
    "validado": true,
    "resultado": "RJ"
  },
  "concatenar": {
    "exemplo": "concatenar(\"R$ \",{@VALOR})",
    "variaveis": [
      {
        "key": "@VALOR",
        "value": "149,90",
        "type": "TEXTO"
      }
    ],
    "runnable": true,
    "retorna": "texto",
    "combina": "concatena os args (use *SPACE* pra espaco); igual a concatenar2, entra em qualquer arg de texto",
    "cat": "texto",
    "validado": true,
    "resultado": "R$149,90"
  },
  "encodeString2": {
    "exemplo": "encodeString2(\"Promoção \\\"verão\\\" & cia\")",
    "variaveis": [],
    "runnable": true,
    "retorna": "texto",
    "combina": "codifica string pra HTML (preserva tokens {@...}); use antes de montar corpo HTML/XML",
    "cat": "texto",
    "validado": true,
    "resultado": "Promo%C3%A7%C3%A3o%20%5C%22ver%C3%A3o%5C%22%20%26%20cia"
  },
  "removerAcentos": {
    "exemplo": "removerAcentos(\"São Paulo é ótimo\")",
    "variaveis": [],
    "runnable": true,
    "retorna": "texto",
    "combina": "tira acentos E coloca em MAIUSCULO (efeito colateral); use em campos que nao aceitam acento no ERP",
    "cat": "texto",
    "validado": true,
    "resultado": "SAO PAULO E OTIMO"
  },
  "leftPad": {
    "exemplo": "leftPad({@CODLOJA},6,\"0\")",
    "variaveis": [
      {
        "key": "@CODLOJA",
        "value": "42",
        "type": "TEXTO"
      }
    ],
    "runnable": true,
    "retorna": "texto",
    "combina": "completa a esquerda ate o tamanho; classico depois de onlyNumbers pra zerar a esquerda codigos/EAN",
    "cat": "texto",
    "validado": true,
    "resultado": "000042"
  },
  "leftString": {
    "exemplo": "leftString({@DESC},30)",
    "variaveis": [
      {
        "key": "@DESC",
        "value": "Camiseta básica de algodão pima manga curta",
        "type": "TEXTO"
      }
    ],
    "runnable": true,
    "retorna": "texto",
    "combina": "pega os N primeiros chars (sem estourar); use pra truncar titulo/descricao ao limite do marketplace",
    "cat": "texto",
    "validado": true,
    "resultado": "Camiseta básica de algodão pim"
  },
  "rightPad": {
    "exemplo": "rightPad({@CODIGO},10,\" \")",
    "variaveis": [
      {
        "key": "@CODIGO",
        "value": "ABC12",
        "type": "TEXTO"
      }
    ],
    "runnable": true,
    "retorna": "texto",
    "combina": "completa a direita ate o tamanho; util pra layouts posicionais (EDI/arquivo de remessa)",
    "cat": "texto",
    "validado": true,
    "resultado": "ABC12     "
  },
  "removeEspacos": {
    "exemplo": "removeEspacos(\"  pedido 998877  \")",
    "variaveis": [],
    "runnable": true,
    "retorna": "texto",
    "combina": "faz trim (igual a trim) das pontas; aninha antes de comparar/concatenar valores vindos de planilha",
    "cat": "texto",
    "validado": true,
    "resultado": "pedido 998877"
  },
  "removerLB": {
    "exemplo": "removerLB({@OBS})",
    "variaveis": [
      {
        "key": "@OBS",
        "value": "linha1\nlinha2\nlinha3",
        "type": "TEXTO"
      }
    ],
    "runnable": true,
    "retorna": "texto",
    "combina": "remove quebras de linha (enter/CR/LF); use em texto multilinha antes de gravar em JSON/CSV de uma linha",
    "cat": "texto",
    "validado": true,
    "resultado": "linha1linha2linha3"
  },
  "sanitizeForXml": {
    "exemplo": "sanitizeForXml(\"Texto com\u0001char inválido & cia\")",
    "variaveis": [],
    "runnable": true,
    "retorna": "texto",
    "combina": "remove chars de controle invalidos pra XML; use antes de toXMLArray/SelectXml ou de gerar XML de NF",
    "cat": "texto",
    "validado": true,
    "resultado": "T"
  },
  "sanitizeXml": {
    "exemplo": "sanitizeXml(\"Açaí € símbolo ñ\")",
    "variaveis": [],
    "runnable": true,
    "retorna": "texto",
    "combina": "tira caracteres nao-ASCII; use quando o destino so aceita ASCII puro (legado/EDI)",
    "cat": "texto",
    "validado": true,
    "resultado": "Açaí € símbolo ñ"
  },
  "lenSize": {
    "exemplo": "lenSize({@DESC})",
    "variaveis": [
      {
        "key": "@DESC",
        "value": "Camiseta básica de algodão",
        "type": "TEXTO"
      }
    ],
    "runnable": true,
    "retorna": "numero",
    "combina": "tamanho da string; combina com ifThenElse pra decidir se trunca (ex.: leftString) quando passa do limite",
    "cat": "texto",
    "validado": true,
    "resultado": "26"
  },
  "decodeString": {
    "exemplo": "decodeString(\"Cami&ccedil;a P&amp;M\")",
    "variaveis": [],
    "runnable": true,
    "retorna": "texto",
    "combina": "decodifica HTML entities de volta pra texto; par inverso de encodeString, use no texto vindo de HTML do marketplace",
    "cat": "texto",
    "validado": true,
    "resultado": "Cami&ccedil;a P&amp;M"
  },
  "removerCaracteresEspeciais2": {
    "exemplo": "removerCaracteresEspeciais2(\"Caçá#@!ção/ç\")",
    "variaveis": [],
    "runnable": true,
    "retorna": "texto",
    "combina": "variante de removerCaracteresEspeciais; entra em qualquer arg de texto pra limpar campo antes de gravar",
    "cat": "texto",
    "validado": true,
    "resultado": "Caçá#@!ção/ç"
  },
  "onlyAlphaNumbersSpace": {
    "exemplo": "onlyAlphaNumbersSpace(\"NF-e 123 #ABC/45\")",
    "variaveis": [],
    "runnable": true,
    "retorna": "texto",
    "combina": "mantem letras, numeros e espaco; bom pra titulo de anuncio onde so espaco e permitido como separador",
    "cat": "texto",
    "validado": true,
    "resultado": "NF e 123  ABC 45"
  },
  "replace": {
    "exemplo": "replace({@VALOR},\".\",\",\")",
    "variaveis": [
      {
        "key": "@VALOR",
        "value": "1499.90",
        "type": "TEXTO"
      }
    ],
    "runnable": true,
    "retorna": "texto",
    "combina": "replace literal (nao regex); arg vazio \"\" zera o trecho; classico pra trocar separador decimal antes de gravar no ERP",
    "cat": "texto",
    "validado": true,
    "resultado": "1499,90"
  },
  "toLowerCase": {
    "exemplo": "toLowerCase({@EMAIL})",
    "variaveis": [
      {
        "key": "@EMAIL",
        "value": "Comprador@LOJA.com.BR",
        "type": "TEXTO"
      }
    ],
    "runnable": true,
    "retorna": "texto",
    "combina": "minusculas; aninha em trim/removeEspacos pra normalizar email/chave antes de comparar",
    "cat": "texto",
    "validado": true,
    "resultado": "comprador@loja.com.br"
  },
  "toUpperCase": {
    "exemplo": "toUpperCase({@UF})",
    "variaveis": [
      {
        "key": "@UF",
        "value": "sp",
        "type": "TEXTO"
      }
    ],
    "runnable": true,
    "retorna": "texto",
    "combina": "maiusculas; entra em qualquer arg de texto pra padronizar UF/codigo antes de gravar ou comparar",
    "cat": "texto",
    "validado": true,
    "resultado": "SP"
  },
  "trim": {
    "exemplo": "trim(\"  998877  \")",
    "variaveis": [],
    "runnable": true,
    "retorna": "texto",
    "combina": "remove espacos das pontas; envolve valores vindos de planilha/CSV antes de concatenar ou comparar",
    "cat": "texto",
    "validado": true,
    "resultado": "998877"
  },
  "nullValue": {
    "exemplo": "nullValue({@NOME_CLIENTE},\"Sem nome\")",
    "variaveis": [
      {
        "key": "@NOME_CLIENTE",
        "value": "",
        "type": "TEXTO"
      }
    ],
    "runnable": false,
    "retorna": "texto",
    "combina": "entra em qualquer arg de texto para blindar campo opcional antes de concatenar/montar JSON; precisa da variavel de contexto {@NOME_CLIENTE} preenchida (sem ela o exemplo nao e deterministico)",
    "cat": "logica",
    "validado": false,
    "resultado": null
  },
  "noValue": {
    "exemplo": "noValue(\"0\")",
    "variaveis": [],
    "runnable": true,
    "retorna": "booleano",
    "combina": "retorna true/false; use como condicao dentro de ifThenElse(noValue({@X}),...) (trata null, \"\" e \"0\" como vazio)",
    "cat": "logica",
    "validado": true,
    "resultado": "true"
  },
  "executeGroovy": {
    "exemplo": "executeGroovy(\"return 2 + 3\")",
    "variaveis": [],
    "runnable": true,
    "retorna": "texto",
    "combina": "executa Groovy arbitrario com o map de contexto injetado (variavel map); nao e puro/seguro - roda script no servidor e pode tocar contexto/efeitos colaterais. Exemplo deterministico (return 2 + 3 = 5).",
    "cat": "logica",
    "validado": true,
    "resultado": "5"
  },
  "dataSwitch": {
    "exemplo": "dataSwitch({@STATUS},\"A,Aprovado,C,Cancelado,P,Pendente\",\"Desconhecido\")",
    "variaveis": [
      {
        "key": "@STATUS",
        "value": "A",
        "type": "TEXTO"
      }
    ],
    "runnable": true,
    "retorna": "texto",
    "combina": "IF simplificado: casa o valor com pares chave,resultado e cai no default; entra em qualquer arg de texto. Puro na logica, mas o exemplo le {@STATUS} do contexto",
    "cat": "logica",
    "validado": true,
    "resultado": "Aprovado"
  },
  "ifThenElse": {
    "exemplo": "ifThenElse(\"10 > 5\",\"maior\",\"menor\")",
    "variaveis": [],
    "runnable": true,
    "retorna": "texto",
    "combina": "condicao tem que ser expressao booleana avaliavel (BeanShell); aninha bem com noValue/regexTest no 1o arg e com qualquer funcao de texto nos ramos entao/senao",
    "cat": "logica",
    "validado": true,
    "resultado": "maior"
  },
  "executeFormula": {
    "exemplo": "executeFormula(\"add(2,3)\",true)",
    "variaveis": [],
    "runnable": true,
    "retorna": "texto",
    "combina": "re-executa uma formula TemAPI (segundo arg = motor novo true/false) reusando o map da thread; depende do contexto/outras funcoes, evite marcar como puro",
    "cat": "logica",
    "validado": true,
    "resultado": "5"
  },
  "executeGroovyScript": {
    "exemplo": "executeGroovyScript(\"calculaFrete\",\"cep=01001000;peso=2\")",
    "variaveis": [],
    "runnable": false,
    "retorna": "texto",
    "combina": "roda um script Groovy armazenado (entidade Mktpgroovy) por nome, injetando params no contexto; precisa do script cadastrado no banco/cache do tenant - nao e puro",
    "cat": "logica",
    "validado": false,
    "resultado": null
  },
  "toJSONArray": {
    "exemplo": "toJSONArray({@PEDIDO},$.items,sku=$.codigo;qtd=$.quantidade)",
    "variaveis": [
      {
        "key": "@PEDIDO",
        "value": "{\"items\":[{\"codigo\":\"A1\",\"quantidade\":2},{\"codigo\":\"B2\",\"quantidade\":5}]}",
        "type": "JSON"
      }
    ],
    "runnable": false,
    "retorna": "json",
    "combina": "retorna JSONArray; use dentro de stringify/jsonToCsv ou alimentando createJSONArray. Precisa do globalMap (@detailJSON) do contexto de execucao, entao nao roda isolado no /test puro.",
    "cat": "json",
    "validado": false,
    "resultado": null
  },
  "byteToXmlJson": {
    "exemplo": "byteToXmlJson({@ARQUIVO},JSON,UTF-8)",
    "variaveis": [
      {
        "key": "@ARQUIVO",
        "value": "byteArray do contexto (Clob/byte[] vindo de um request anterior)",
        "type": "TEXTO"
      }
    ],
    "runnable": false,
    "retorna": "texto",
    "combina": "converte um byte[]/Clob (binario do contexto, tipico de download de marketplace) em XML ou JSON string; o resultado JSON entra em findJSON2/stringify. Precisa de variavel binaria real, nao roda com literal.",
    "cat": "json",
    "validado": false,
    "resultado": null
  },
  "stringify": {
    "exemplo": "stringify({@J},2)",
    "variaveis": [
      {
        "key": "@J",
        "value": "{\"nome\":\"Charles\",\"ativo\":true}",
        "type": "JSON"
      }
    ],
    "runnable": true,
    "retorna": "texto",
    "combina": "serializa JSONObject/JSONArray em string (ident=0 compacto, >0 indentado); fecha o pipe depois de toJSONArray/arrayToObject/findJSON3. Entra em qualquer arg de texto.",
    "cat": "json",
    "validado": true,
    "resultado": "{  \"ativo\": true,  \"nome\": \"Charles\"}"
  },
  "executeSqlJSON": {
    "exemplo": "executeSqlJSON(\"SELECT NOME FROM MKTPEXEMPLO (NOLOCK) WHERE ID=1\",rows)",
    "variaveis": [],
    "runnable": true,
    "retorna": "json",
    "combina": "roda SQL raw e devolve JSONArray sob a tag informada; aninhe com findJSON2/stringify. Roda SQL no tenant (precisa de DB; em tabela com CODECOMPANY use filtro de tenant - REGRA #1). Exemplo usa a tabela dedicada MKTPEXEMPLO.",
    "cat": "json",
    "validado": true,
    "resultado": "{\"rows\":[{\"NOME\":\"ALPHA\"}]}"
  },
  "jsonToCsv": {
    "exemplo": "jsonToCsv({@LINHAS},;)",
    "variaveis": [
      {
        "key": "@LINHAS",
        "value": "[{\"sku\":\"A1\",\"qtd\":2},{\"sku\":\"B2\",\"qtd\":5}]",
        "type": "JSON"
      }
    ],
    "runnable": true,
    "retorna": "texto",
    "combina": "achata JSONObject/JSONArray em CSV com o delimitador dado; bom no fim do pipe apos toJSONArray/executeSqlJSON. Saida de texto puro.",
    "cat": "json",
    "validado": true,
    "resultado": "qtd;sku2;A15;B2"
  },
  "graphQLToJSON": {
    "exemplo": "graphQLToJSON(\"query{order(id:1){total status}}\",\"orderId=1\")",
    "variaveis": [],
    "runnable": true,
    "retorna": "json",
    "combina": "converte texto de query GraphQL em JSON estruturado (nao executa a query); o JSON resultante pode virar body de request ou entrar em findJSON2. Transformacao pura de texto. 2o arg = pares chave=valor separados por ;",
    "cat": "json",
    "validado": true,
    "resultado": "{\"query\":\"query{order(id:1){total status}}\",\"variables\":{\"orderId\":\"1\"}}"
  },
  "findJSON": {
    "exemplo": "findJSON({@J},pedido.cliente.nome,cliente.nome)",
    "variaveis": [
      {
        "key": "@J",
        "value": "{\"pedido\":{\"cliente\":{\"nome\":\"Charles\"}}}",
        "type": "JSON"
      }
    ],
    "runnable": true,
    "retorna": "texto",
    "combina": "busca valor por path NATIVO (dot, sem $); overload com 2 paths faz fallback. Retorna \"0\" se nao achar e \"##\" se vazio. Entra em qualquer arg de texto; aninha bem dentro de toUpperCase/ifThenElse.",
    "cat": "json",
    "validado": true,
    "resultado": "Charles"
  },
  "escapeJSON": {
    "exemplo": "escapeJSON({@J})",
    "variaveis": [
      {
        "key": "@J",
        "value": "{\"msg\":\"ola \\\"mundo\\\"\"}",
        "type": "JSON"
      }
    ],
    "runnable": true,
    "retorna": "texto",
    "combina": "valida e re-serializa o JSON (normaliza), util antes de embutir em outro JSON/body. Saida de texto JSON; aninha com stringify/removeScapeJson.",
    "cat": "json",
    "validado": true,
    "resultado": "{\"msg\":\"ola \\\"mundo\\\"\"}"
  },
  "removeScapeJson": {
    "exemplo": "removeScapeJson({@J})",
    "variaveis": [
      {
        "key": "@J",
        "value": "{\\\"nome\\\":\\\"Charles\\\"}",
        "type": "TEXTO"
      }
    ],
    "runnable": true,
    "retorna": "texto",
    "combina": "remove escapes (\\\" -> \") e re-parseia o JSON; usa-se quando um JSON chegou escapado dentro de outro. Inverso pratico do escapeJSON.",
    "cat": "json",
    "validado": true,
    "resultado": "{\"nome\":\"Charles\"}"
  },
  "arrayToObject": {
    "exemplo": "arrayToObject({@SKUS},sku)",
    "variaveis": [
      {
        "key": "@SKUS",
        "value": "[\"A1\",\"B2\",\"C3\"]",
        "type": "JSON"
      }
    ],
    "runnable": false,
    "retorna": "json",
    "combina": "envolve cada elemento de um JSONArray em um objeto {obName:valor}; o array resultante entra em stringify/jsonToCsv. Retorna JSONArray.",
    "cat": "json",
    "validado": false,
    "resultado": null
  },
  "isJson": {
    "exemplo": "isJson({@TXT})",
    "variaveis": [
      {
        "key": "@TXT",
        "value": "{\"ok\":1}",
        "type": "TEXTO"
      }
    ],
    "runnable": true,
    "retorna": "booleano",
    "combina": "true/false se a string e JSON valido (objeto ou array); ideal como condicao do ifThenElse antes de chamar findJSON/stringify.",
    "cat": "json",
    "validado": true,
    "resultado": "true"
  },
  "findJSON3": {
    "exemplo": "findJSON3({@J},$.pedido.itens)",
    "variaveis": [
      {
        "key": "@J",
        "value": "{\"pedido\":{\"itens\":[{\"sku\":\"A1\"},{\"sku\":\"B2\"}]}}",
        "type": "JSON"
      }
    ],
    "runnable": true,
    "retorna": "json",
    "combina": "busca por path JAYWAY ($) e retorna o OBJETO/array como string (nao achatado); retorna {} em erro. Use quando precisa do sub-JSON inteiro p/ stringify/toJSONArray.",
    "cat": "json",
    "validado": true,
    "resultado": "[{\"sku\":\"A1\"},{\"sku\":\"B2\"}]"
  },
  "findJSON2": {
    "exemplo": "findJSON2({@J},$.pedido.cliente.nome)",
    "variaveis": [
      {
        "key": "@J",
        "value": "{\"pedido\":{\"cliente\":{\"nome\":\"Charles\"}}}",
        "type": "JSON"
      }
    ],
    "runnable": true,
    "retorna": "texto",
    "combina": "busca por path JAYWAY ($); quando o path casa array junta os valores por virgula, retorna \"0\" se nao achar. Aninha bem em toUpperCase/ifThenElse e em qualquer arg de texto.",
    "cat": "json",
    "validado": true,
    "resultado": "Charles"
  },
  "xml2json": {
    "exemplo": "xml2json({@XML},FALSE)",
    "variaveis": [
      {
        "key": "@XML",
        "value": "<pedido><id>1231</id><status>OK</status></pedido>",
        "type": "XML"
      }
    ],
    "runnable": true,
    "retorna": "json",
    "combina": "converte XML em JSONObject (ou JSONArray de 1 elemento se isArray=TRUE); o JSON sai pronto p/ findJSON2/stringify. Entrada XML do contexto ou literal.",
    "cat": "json",
    "validado": true,
    "resultado": "{\"pedido\":{\"id\":1231,\"status\":\"OK\"}}"
  },
  "createJSONArray": {
    "exemplo": "createJSONArray({@ITENS},\"SELECT NOME FROM MKTPEXEMPLO (NOLOCK) WHERE ID=:idex\",idex=$.id)",
    "variaveis": [
      {
        "key": "@ITENS",
        "value": "[{\"id\":1}]",
        "type": "JSON"
      }
    ],
    "runnable": true,
    "retorna": "json",
    "combina": "para cada linha do array roda a query (param=path JAYWAY; SEQUENCE_ARRAY = indice) e monta JSONArray com os resultados. Roda SQL no tenant (DB). Exemplo usa a tabela dedicada MKTPEXEMPLO.",
    "cat": "json",
    "validado": true,
    "resultado": "[{\"NOME\":\"ALPHA\"}]"
  },
  "toSankhyaJSON": {
    "exemplo": "toSankhyaJSON({@DBEXPLORER},TRUE,FALSE)",
    "variaveis": [
      {
        "key": "@DBEXPLORER",
        "value": "{\"responseBody\":{\"fieldsMetadata\":[{\"name\":\"NUNOTA\",\"userType\":\"I\"},{\"name\":\"CLIENTE\",\"userType\":\"S\"}],\"rows\":[[123,\"Charles\"]]}}",
        "type": "JSON"
      }
    ],
    "runnable": true,
    "retorna": "json",
    "combina": "normaliza o retorno cru do DBExplorer Sankhya (fieldsMetadata+rows) em JSONArray de objetos {campo:valor}; ordered preserva ordem, tagLowCase baixa as chaves. Saida entra em findJSON2/stringify.",
    "cat": "json",
    "validado": true,
    "resultado": "{\"SQL\":[{\"NUNOTA\":123,\"CLIENTE\":\"Charles\"}]}"
  },
  "transformJSONArray": {
    "exemplo": "transformJSONArray({@ARR},cliente.nome)",
    "variaveis": [
      {
        "key": "@ARR",
        "value": "[{\"cliente\":{\"nome\":\"Charles\"}}]",
        "type": "JSON"
      }
    ],
    "runnable": false,
    "retorna": "texto",
    "combina": "pega o 1o objeto do JSONArray e busca o path NATIVO (dot, sem $) dentro dele; retorna \"0\" em erro. Use quando a fonte e array mas voce so quer um campo do primeiro item.",
    "cat": "json",
    "validado": false,
    "resultado": null
  },
  "findJSON2Operation": {
    "exemplo": "findJSON2Operation({@J},$.itens[*].valor,SUM)",
    "variaveis": [
      {
        "key": "@J",
        "value": "{\"itens\":[{\"valor\":\"10.50\"},{\"valor\":\"4.50\"}]}",
        "type": "JSON"
      }
    ],
    "runnable": true,
    "retorna": "numero",
    "combina": "busca array por path JAYWAY ($) e agrega (SUM/MAX/MIN) os valores numericos; bom p/ totalizar itens de pedido. Saida numerica entra em add/roundValue.",
    "cat": "json",
    "validado": true,
    "resultado": "15.00"
  },
  "transformJSONObject": {
    "exemplo": "transformJSONObject({@J},pedido.status)",
    "variaveis": [
      {
        "key": "@J",
        "value": "{\"pedido\":{\"status\":\"APROVADO\"}}",
        "type": "JSON"
      }
    ],
    "runnable": true,
    "retorna": "texto",
    "combina": "busca path NATIVO (dot, sem $) num JSONObject; retorna \"0\" em erro. Equivale ao findJSON nativo p/ objeto; aninha em ifThenElse/toUpperCase e em qualquer arg de texto.",
    "cat": "json",
    "validado": true,
    "resultado": "APROVADO"
  },
  "getDate": {
    "exemplo": "getDate()",
    "variaveis": [],
    "runnable": true,
    "retorna": "data",
    "combina": "retorna a data/hora atual em yyyy-MM-dd HH:mm:ss.SSS; encaixa direto em formatDate/truncDate/datePart. Nao-deterministico (relogio do servidor).",
    "cat": "data",
    "validado": false,
    "resultado": null
  },
  "parseDate": {
    "exemplo": "parseDate(\"2026-06-04T09:30:00-03:00\",\"yyyy-MM-dd HH:mm:ss\")",
    "variaveis": [],
    "runnable": true,
    "retorna": "texto",
    "combina": "le data ISO-8601 com offset (ZonedDateTime) e devolve no padrao informado; ideal logo apos findJSON de campo de data de API. Em falha retorna \"Nao foi possivel formatar data\".",
    "cat": "data",
    "validado": true,
    "resultado": "2026-06-04 09:30:00"
  },
  "formatDate": {
    "exemplo": "formatDate(\"2026-06-04 09:30:00.000\",\"dd/MM/yyyy HH:mm\")",
    "variaveis": [],
    "runnable": true,
    "retorna": "texto",
    "combina": "2 args assume entrada fixa yyyy-MM-dd HH:mm:ss.SSS; 3 args formatDate(data,formatoDe,formatoPara) converte de qualquer padrao. Aninha bem em volta de findJSON/getDate. Em falha retorna \"Formato Invalido\".",
    "cat": "data",
    "validado": true,
    "resultado": "04/06/2026 09:30"
  },
  "toTimestamp": {
    "exemplo": "toTimestamp(\"2026-06-04 09:30:00\")",
    "variaveis": [],
    "runnable": true,
    "retorna": "numero",
    "combina": "data -> epoch em SEGUNDOS (parser flexivel DateUtils); usar dentro de assinaturas/headers de marketplace que pedem unix time. Em erro retorna \"0\".",
    "cat": "data",
    "validado": true,
    "resultado": "1780576200"
  },
  "truncDate": {
    "exemplo": "truncDate(\"2026-06-04 09:30:00\",\"yyyy-MM-dd HH:mm:ss\")",
    "variaveis": [],
    "runnable": true,
    "retorna": "texto",
    "combina": "zera hora/min/seg/milis e devolve no MESMO padrao informado (le e escreve com o mesmo format); bom para agrupar por dia. Pode aninhar getDate dentro.",
    "cat": "data",
    "validado": true,
    "resultado": "2026-06-04 00:00:00"
  },
  "datePart": {
    "exemplo": "datePart(\"2026-06-04 09:30:00.000\",\"MONTH\")",
    "variaveis": [],
    "runnable": true,
    "retorna": "numero",
    "combina": "entrada FIXA yyyy-MM-dd HH:mm:ss.SSS; part = YEAR|MONTH|DAY|HOUR|MINUTE|SECOND|MILLI (MONTH ja vem 1-based). Sai numero, encaixa em ifThenElse/comparacoes.",
    "cat": "data",
    "validado": true,
    "resultado": "6"
  },
  "sumHours": {
    "exemplo": "sumHours(\"2026-06-04 09:30:00\",\"3600\",\"yyyy-MM-dd HH:mm:ss\")",
    "variaveis": [],
    "runnable": true,
    "retorna": "texto",
    "combina": "soma SEGUNDOS na data. 3 args (data,segundos,format) le no format e SAI sempre dd/MM/yyyy HH:mm:ss; 4 args (data,seg,formatIn,formatOut) controla a saida. Aceita segundos negativos para subtrair.",
    "cat": "data",
    "validado": true,
    "resultado": "04/06/2026 10:30:00"
  },
  "sumDays": {
    "exemplo": "sumDays(\"2026-06-04 09:30:00\",\"7\",\"yyyy-MM-dd HH:mm:ss\")",
    "variaveis": [],
    "runnable": true,
    "retorna": "texto",
    "combina": "soma DIAS na data. 3 args le no format e SAI sempre dd/MM/yyyy HH:mm:ss; 4 args (data,dias,formatIn,formatOut) define a saida. Dias negativos retrocedem; util para D+N de prazo.",
    "cat": "data",
    "validado": true,
    "resultado": "11/06/2026 09:30:00"
  },
  "createDate": {
    "exemplo": "createDate(2026,6,4,9,30,0,0,\"yyyy-MM-dd HH:mm:ss\")",
    "variaveis": [],
    "runnable": true,
    "retorna": "texto",
    "combina": "monta data a partir de ano,mes(1-based),dia,hora,min,seg,mili e formata no padrao final; bom para fabricar data fixa sem depender de getDate.",
    "cat": "data",
    "validado": true,
    "resultado": "2026-06-04 09:30:00"
  },
  "formatDateUTC": {
    "exemplo": "formatDateUTC(\"2026-06-04 09:30:00.000\",\"yyyy-MM-dd'T'HH:mm:ss'Z'\")",
    "variaveis": [],
    "runnable": true,
    "retorna": "texto",
    "combina": "le entrada FIXA yyyy-MM-dd HH:mm:ss.SSS no fuso local e converte para UTC no format informado; usar para timestamps de API que exigem Zulu/UTC. Em falha retorna \"Formato Invalido\".",
    "cat": "data",
    "validado": true,
    "resultado": "2026-06-04T12:30:00Z"
  },
  "parseTimestamp": {
    "exemplo": "parseTimestamp(\"1780000000\",\"yyyy-MM-dd HH:mm:ss\")",
    "variaveis": [],
    "runnable": true,
    "retorna": "texto",
    "combina": "epoch em SEGUNDOS -> data formatada no padrao (inverso de toTimestamp); encaixa apos findJSON de campo unix de marketplace. Em erro retorna \"0\".",
    "cat": "data",
    "validado": true,
    "resultado": "2026-05-28 17:26:40"
  },
  "getAmazonSignatureDateAWS": {
    "exemplo": "getAmazonSignatureDateAWS()",
    "variaveis": [],
    "runnable": false,
    "retorna": "texto",
    "combina": "le a data de assinatura do ThreadLocal authUtil; SO funciona depois de getAmazonSignatureAWS/addAmazonHeaderAWS terem rodado na mesma thread. Sem esse contexto Amazon, falha/retorna vazio.",
    "cat": "data",
    "validado": false,
    "resultado": null
  },
  "toTimestampWithMilis": {
    "exemplo": "toTimestampWithMilis(\"2026-06-04 09:30:00\")",
    "variaveis": [],
    "runnable": true,
    "retorna": "numero",
    "combina": "data -> epoch em MILISSEGUNDOS (parser flexivel DateUtils); para APIs que pedem unix em ms. Em erro retorna \"0\".",
    "cat": "data",
    "validado": true,
    "resultado": "1780576200000"
  },
  "JArray2XArray": {
    "exemplo": "JArray2XArray({@LINHAS},\"itens\",\"item\")",
    "variaveis": [
      {
        "key": "@LINHAS",
        "value": "{\"SQL\":[{\"CODIGO\":\"1\",\"NOME\":\"CAMISETA\"},{\"CODIGO\":\"2\",\"NOME\":\"BONE\"}]}",
        "type": "JSON"
      }
    ],
    "runnable": true,
    "retorna": "xml",
    "combina": "recebe JSON com array na tag SQL (ou via path no overload de 4 args) e devolve XML; alimente com saida de executeSqlJSON e jogue o XML em SelectXml/selectXML2",
    "cat": "xml",
    "validado": true,
    "resultado": "<itens><item><CODIGO>1</CODIGO><NOME>CAMISETA</NOME></item><item><CODIGO>2</CODIGO><NOME>BONE</NOME></item></itens>"
  },
  "SelectXml": {
    "exemplo": "SelectXml({@PEDIDO},\"//cliente/nome\",\"0\")",
    "variaveis": [
      {
        "key": "@PEDIDO",
        "value": "<pedido><cliente><nome>Maria Silva</nome></cliente></pedido>",
        "type": "XML"
      }
    ],
    "runnable": true,
    "retorna": "texto",
    "combina": "extrai o texto de um no via SimpleXPath; line=0 pega no unico, line>=1 pega o n-esimo; entra em qualquer arg de texto ou aninha com nullValue",
    "cat": "xml",
    "validado": true,
    "resultado": "Maria Silva"
  },
  "toXMLArray": {
    "exemplo": "toXMLArray({@ITENS},\"$\",\"item\",\"sku=codigo;descricao=nome\")",
    "variaveis": [
      {
        "key": "@ITENS",
        "value": "[{\"codigo\":\"10\",\"nome\":\"Tenis Run\"},{\"codigo\":\"11\",\"nome\":\"Meia Par\"}]",
        "type": "JSON"
      }
    ],
    "runnable": true,
    "retorna": "xml",
    "combina": "converte JSON Array em XML mapeando campos no formato tag=expr;tag2=expr2 (path JSONPath); use a saida em selectXML2/SelectXml. applyFormulaValue=true encadeia formulas por valor",
    "cat": "xml",
    "validado": true,
    "resultado": "<item><sku>11</sku><descricao>Meia Par</descricao></item>"
  },
  "selectXML2": {
    "exemplo": "selectXML2({@NFE},\"/NFe/infNFe/emit/CNPJ\")",
    "variaveis": [
      {
        "key": "@NFE",
        "value": "<NFe><infNFe><emit><CNPJ>12345678000199</CNPJ></emit></infNFe></NFe>",
        "type": "XML"
      }
    ],
    "runnable": true,
    "retorna": "texto",
    "combina": "XPath JDOM que retorna o valor (texto) do no/atributo casado; entra em qualquer arg de texto e aninha bem com onlyNumbers/trim",
    "cat": "xml",
    "validado": true,
    "resultado": "12345678000199"
  },
  "selectXML3": {
    "exemplo": "selectXML3({@RESP},\"//status\")",
    "variaveis": [
      {
        "key": "@RESP",
        "value": "<resposta><status>OK</status><id>987</id></resposta>",
        "type": "XML"
      }
    ],
    "runnable": true,
    "retorna": "xml",
    "combina": "avalia o XPath mas retorna o documento XML inteiro como string (nao so o no); use quando precisa repassar o XML completo adiante",
    "cat": "xml",
    "validado": true,
    "resultado": "<resposta><status>OK</status><id>987</id></resposta>"
  },
  "toJDOM": {
    "exemplo": "toJDOM({@DOC})",
    "variaveis": [
      {
        "key": "@DOC",
        "value": "<root><a>1</a></root>",
        "type": "XML"
      }
    ],
    "runnable": false,
    "retorna": "objeto",
    "combina": "converte string XML em org.jdom.Document para reaproveitar como entrada de SelectXml sem reparsear; retorna objeto, nao texto, entao so faz sentido aninhado dentro de outra funcao XML que aceite Document",
    "cat": "xml",
    "validado": false,
    "resultado": null
  },
  "getRequestDataXML": {
    "exemplo": "getRequestDataXML(\"GET\",\"https://api.correios.com.br/sigep/v1/rastro\",{@BODY},\"\",\"\",\"\",\"\",\"UTF-8\")",
    "variaveis": [
      {
        "key": "@BODY",
        "value": "<consulta><objetos>BR123456789BR</objetos></consulta>",
        "type": "XML"
      }
    ],
    "runnable": false,
    "retorna": "xml",
    "combina": "faz request HTTP a um servico SOAP/XML e devolve a resposta XML; precisa de rede/endpoint (e geralmente credencial), use a saida em SelectXml/selectXML2",
    "cat": "xml",
    "validado": false,
    "resultado": null
  },
  "executeProcedure": {
    "exemplo": "executeProcedure(\"STP_ATUALIZA_STATUS\",{@PARAMIN},\"RESULT\")",
    "variaveis": [
      {
        "key": "@PARAMIN",
        "value": "[{\"name\":\"IDCONF\",\"value\":\"1\"},{\"name\":\"STATUS\",\"value\":\"N\"}]",
        "type": "JSON"
      }
    ],
    "runnable": true,
    "retorna": "texto",
    "combina": "Chama stored procedure no SQL Server e devolve o param de saida RESULT (VARCHAR). paramIn e um JSONArray de {name,value} -- passe via variavel ({@PARAMIN}) e NAO inline, pois as aspas/virgulas do JSON colidem com o parser de argumentos da formula. Injeta IDSESSAO automaticamente e sempre adiciona RESULT como OUTPUT (nao inclua RESULT no paramIn). A SP deve ter assinatura (@IDSESSAO, @RESULT OUTPUT) e ler os demais params via SPEXECPROC. Roda no banco do tenant.",
    "cat": "sql",
    "validado": true,
    "resultado": "OK"
  },
  "executeSql": {
    "exemplo": "executeSql(\"NOME\",\"MKTPEXEMPLO (NOLOCK)\",\"ID=1\")",
    "variaveis": [],
    "runnable": true,
    "retorna": "texto",
    "combina": "Monta SELECT <field> FROM <table> WHERE <where> e retorna o 1o valor da 1a linha (\"null\" se nulo, \"0\" se vazio). NAO injeta tenant: em tabela com CODECOMPANY o filtro tem que estar no proprio where (REGRA #1). Exemplo usa a tabela dedicada MKTPEXEMPLO.",
    "cat": "sql",
    "validado": true,
    "resultado": "ALPHA"
  },
  "getContractPref": {
    "exemplo": "getContractPref(\"priceQuery\",\"\",\"0\")",
    "variaveis": [],
    "runnable": false,
    "retorna": "texto",
    "combina": "Le TEXT de MKTPCONTRACTPREF (tabela REAL do sistema, com FK p/ MKTPCOMPANIES) casando NAME + CODECONTRACT/CODECOMPANY/CODEMKTP do contexto. Nao roda no laboratorio isolado: depende de preferencia de contrato real cadastrada. Valide em ambiente com dados.",
    "cat": "sql",
    "validado": false,
    "resultado": null
  },
  "getToData": {
    "exemplo": "getToData(\"PENDENTE\",\"STATUS_PEDIDO\")",
    "variaveis": [
      { "key": "@CODECOMPANYRUNTIME", "value": "99990", "type": "TEXTO" },
      { "key": "@CODEMKTPRUNTIME", "value": "99990", "type": "TEXTO" }
    ],
    "runnable": true,
    "retorna": "texto",
    "combina": "De/Para da MKTPFROMTODATA: dado FROMDATA (+ TAGNAME opcional) retorna TODATA; \"0\" se nao houver match. CODECOMPANY/CODEMKTP vem do contexto; aqui via @CODECOMPANYRUNTIME/@CODEMKTPRUNTIME apontando o tenant de exemplo isolado 99990 (nao colide com cliente real). Precisa do banco do tenant.",
    "cat": "sql",
    "validado": true,
    "resultado": "Aguardando Pagamento"
  },
  "inUnion": {
    "exemplo": "inUnion(\"SELECT ID FROM MKTPEXEMPLO (NOLOCK) WHERE ID IN (P1)\",5,\"P1:SELECT TOP 3 ID FROM MKTPEXEMPLO (NOLOCK) WHERE CODECOMPANY=0 ORDER BY ID\")",
    "variaveis": [],
    "runnable": true,
    "retorna": "texto",
    "combina": "Roda cada consulta de params (formato nome:query;...), fatia os resultados em blocos de qtd e gera o select repetido com UNION ALL trocando o placeholder (P1) pelos valores. Serve pra estourar IN gigante. Saida = SQL pronto pra rodar; precisa do banco do tenant.",
    "cat": "sql",
    "validado": true,
    "resultado": "SELECT ID FROM MKTPEXEMPLO (NOLOCK) WHERE ID IN ('1','2','3')"
  },
  "inOracle": {
    "exemplo": "inOracle(\"SELECT TOP 5 ID FROM MKTPEXEMPLO (NOLOCK) WHERE CODECOMPANY=0 ORDER BY ID\",\"I.ID\",\"IN\",\"OR\",\"1000\",true)",
    "variaveis": [],
    "runnable": true,
    "retorna": "texto",
    "combina": "Roda o select, agrupa os valores em blocos de limit e monta predicado tipo (P.SKU IN (...) OR P.SKU IN (...)) p/ furar o teto de 1000 itens do Oracle. isString=true poe aspas; vazio vira (P.SKU IN ('0')). Cole no WHERE de outra query; precisa do banco do tenant.",
    "cat": "sql",
    "validado": true,
    "resultado": "(I.ID IN ( '1','2','3','4','5' ))"
  },
  "inCollection": {
    "exemplo": "inCollection(\"SELECT TOP 5 ID FROM MKTPEXEMPLO (NOLOCK) WHERE CODECOMPANY=0 ORDER BY ID\")",
    "variaveis": [],
    "runnable": true,
    "retorna": "texto",
    "combina": "Roda o select e devolve os valores da 1a coluna SEM aspas entre parenteses, ex: (101,102,103); vazio vira (0). Use direto num IN numerico de outra query. Multi-tenant e do select; precisa do banco do tenant.",
    "cat": "sql",
    "validado": true,
    "resultado": "(1,2,3,4,5)"
  },
  "getActiveCompanies": {
    "exemplo": "getActiveCompanies(\"1\",\"3\",\"STATUS\")",
    "variaveis": [],
    "runnable": false,
    "retorna": "texto",
    "combina": "Le um campo de MKTPACTIVECOMPANIES (tabela REAL do sistema, com FK p/ empresa+marketplace) pela PK codecompany+codemktp. Nao roda no laboratorio isolado: depende de empresa/marketplace ativos reais. field e o nome da coluna em MAIUSCULO (ex: STATUS, APIUSERNAME).",
    "cat": "sql",
    "validado": false,
    "resultado": null
  },
  "inCollectionString": {
    "exemplo": "inCollectionString(\"SELECT NOME FROM MKTPEXEMPLO (NOLOCK) WHERE STATUS='ATIVO' ORDER BY ID\")",
    "variaveis": [],
    "runnable": true,
    "retorna": "texto",
    "combina": "Igual ao inCollection mas COM aspas simples, ex: ('SKU1','SKU2'); vazio vira ('0'). Use num IN de texto. O filtro de tenant tem que estar no select (REGRA #1); precisa do banco do tenant.",
    "cat": "sql",
    "validado": true,
    "resultado": "('ALPHA','BRAVO','DELTA')"
  },
  "mongoFindAgg": {
    "exemplo": "mongoFindAgg(\"MktpExemplo\",{@PIPELINE})",
    "variaveis": [
      {
        "key": "@PIPELINE",
        "value": "[{\"$group\":{\"_id\":\"$STATUS\",\"qtd\":{\"$sum\":1}}}]",
        "type": "TEXTO"
      }
    ],
    "runnable": true,
    "retorna": "json",
    "combina": "Agregacao Mongo: 2o arg e um pipeline BSON (array de stages). Passe via variavel ({@PIPELINE}) pra nao colidir com o parser de args. Usa a collection dedicada de exemplo 'MktpExemplo' (db temapi). Resultado: contagem por STATUS (ordem nao garantida).",
    "cat": "mongo",
    "validado": false,
    "resultado": null
  },
  "mongoFindById": {
    "exemplo": "mongoFindById(\"MktpExemplo\",{@ID})",
    "variaveis": [
      {
        "key": "@ID",
        "value": "EXEMPLO-1",
        "type": "TEXTO"
      }
    ],
    "runnable": true,
    "retorna": "json",
    "combina": "Retorna o documento como JSON; use dentro de findJSON2/findJSON para pegar um campo. Busca pelo _id (ObjectId hex de 24 chars) na collection (entityName em minusculo = nome da collection). Usa a collection dedicada 'MktpExemplo' (db temapi local).",
    "cat": "mongo",
    "validado": false,
    "resultado": null
  },
  "mongoFindFilter": {
    "exemplo": "mongoFindFilter(\"MktpExemplo\",{@FILTRO})",
    "variaveis": [
      {
        "key": "@FILTRO",
        "value": "{\"STATUS\":\"ERRO\"}",
        "type": "TEXTO"
      }
    ],
    "runnable": true,
    "retorna": "json",
    "combina": "Retorna JSON (lista de docs que casam). Passe o filtro via variavel ({@FILTRO}) pra nao colidir com o parser de args. Filtro = sintaxe de query Mongo (BsonDocument.parse). Usa a collection dedicada 'MktpExemplo' (db temapi local).",
    "cat": "mongo",
    "validado": false,
    "resultado": null
  },
  "encodeBase64": {
    "exemplo": "encodeBase64(\"temapi:1234\",false)",
    "variaveis": [],
    "runnable": true,
    "retorna": "texto",
    "combina": "puro; texto entra/sai. isHex=true espera string hexadecimal (decodifica hex e re-encoda Base64). Use o resultado em headers de auth.",
    "cat": "cripto",
    "validado": true,
    "resultado": "dGVtYXBpOjEyMzQ="
  },
  "decodeBase64": {
    "exemplo": "decodeBase64({@TOKEN_B64},false)",
    "variaveis": [
      {
        "key": "@TOKEN_B64",
        "value": "dGVtYXBpOjEyMzQ=",
        "type": "TEXTO"
      }
    ],
    "runnable": true,
    "retorna": "texto",
    "combina": "inverso de encodeBase64; entra em qualquer arg de texto. isHex=true devolve a representacao HEX dos bytes; erro vira sentinela \"0\". Aninha bem em findJSON/findJSON2 do payload decodificado.",
    "cat": "cripto",
    "validado": true,
    "resultado": "temapi:1234"
  },
  "decodeBase64Byte": {
    "exemplo": "decodeBase64Byte({@PAYLOAD_B64},false)",
    "variaveis": [
      {
        "key": "@PAYLOAD_B64",
        "value": "JVBERi0xLjQK",
        "type": "TEXTO"
      }
    ],
    "runnable": false,
    "retorna": "binario",
    "combina": "retorna byte[] (curto-circuita no engine); use quando o proximo passo consome bytes (ex.: convertPdfToZpl, encodeByteBase64). Nao concatene como texto.",
    "cat": "cripto",
    "validado": false,
    "resultado": null
  },
  "encodeByteBase64": {
    "exemplo": "encodeByteBase64({@PDF_BYTES},false)",
    "variaveis": [
      {
        "key": "@PDF_BYTES",
        "value": "byteArray_PDF_BYTES",
        "type": "TEXTO"
      }
    ],
    "runnable": false,
    "retorna": "texto",
    "combina": "recebe byte[] (vem de outra funcao binaria/variavel byteArray, nao de literal) e devolve Base64 texto; encadeia apos getTemporaryFile/decodeBase64Byte.",
    "cat": "cripto",
    "validado": false,
    "resultado": null
  },
  "encodeMD5": {
    "exemplo": "encodeMD5({@REQUESTBODY},true)",
    "variaveis": [
      {
        "key": "@REQUESTBODY",
        "value": "{\"sku\":\"ABC-1\",\"qtd\":3}",
        "type": "TEXTO"
      }
    ],
    "runnable": true,
    "retorna": "texto",
    "combina": "puro; base64=true devolve digest em Base64, false devolve hex. Comum para header Content-MD5; entra em qualquer arg de texto.",
    "cat": "cripto",
    "validado": true,
    "resultado": "u5z8pa5bfScgP4d5FczGLw=="
  },
  "cryptoDataSHA256": {
    "exemplo": "cryptoDataSHA256({@BODY},{@SECRET})",
    "variaveis": [
      {
        "key": "@BODY",
        "value": "id=1001&status=PAID",
        "type": "TEXTO"
      },
      {
        "key": "@SECRET",
        "value": "shop_secret_xxx",
        "type": "TEXTO"
      }
    ],
    "runnable": true,
    "retorna": "texto",
    "combina": "HMAC-SHA256 do value com a chave; puro (deterministico). Saida (hex) costuma entrar em verifyHmacSHA256 ou em header de assinatura.",
    "cat": "cripto",
    "validado": true,
    "resultado": "2ce5afc33df435b609641f6163eff1060214a38246ce5b0efe84aad29aeda541"
  },
  "verifyHmacSHA256": {
    "exemplo": "verifyHmacSHA256({@RAWBODY},{@SECRET},{@SIG_HEADER},true)",
    "variaveis": [
      {
        "key": "@RAWBODY",
        "value": "id=1001&status=PAID",
        "type": "TEXTO"
      },
      {
        "key": "@SECRET",
        "value": "shop_secret_xxx",
        "type": "TEXTO"
      },
      {
        "key": "@SIG_HEADER",
        "value": "2ce5afc33df435b609641f6163eff1060214a38246ce5b0efe84aad29aeda541",
        "type": "TEXTO"
      }
    ],
    "runnable": true,
    "retorna": "booleano",
    "combina": "valida webhook: recalcula HMAC do payload com secret e compara com a assinatura recebida (ignoreCase opcional); puro (deterministico). Use dentro de ifThenElse para aceitar/rejeitar o callback.",
    "cat": "cripto",
    "validado": true,
    "resultado": "true"
  },
  "cryptoData": {
    "exemplo": "cryptoData({@DADO},{@CHAVE},\"AES/CBC/PKCS5Padding\",{@IV},false,true)",
    "variaveis": [
      {
        "key": "@DADO",
        "value": "cpf=12345678900",
        "type": "TEXTO"
      },
      {
        "key": "@CHAVE",
        "value": "0123456789abcdef",
        "type": "TEXTO"
      },
      {
        "key": "@IV",
        "value": "abcdef0123456789",
        "type": "TEXTO"
      }
    ],
    "runnable": true,
    "retorna": "texto",
    "combina": "criptografa via CryptoUtils.encrypt (ALGO/iv/useDigest/base64); puro (deterministico com chave+iv fixos). base64=true devolve string transportavel; par com decryptData.",
    "cat": "cripto",
    "validado": true,
    "resultado": "ITXYVXM2cwAeqmfBphe1Ow=="
  },
  "encryptData": {
    "exemplo": "encryptData({@DADO},{@CHAVE},\"AES/ECB/PKCS5Padding\")",
    "variaveis": [
      {
        "key": "@DADO",
        "value": "token=abc123",
        "type": "TEXTO"
      },
      {
        "key": "@CHAVE",
        "value": "0123456789abcdef",
        "type": "TEXTO"
      }
    ],
    "runnable": true,
    "retorna": "texto",
    "combina": "atalho de cryptoData (iv=null, useDigest=false, base64=true); puro (deterministico com chave fixa). Saida Base64 entra em body/header.",
    "cat": "cripto",
    "validado": true,
    "resultado": "3Qdm4ApJXdTd5R4wcvYBdw=="
  },
  "decryptData": {
    "exemplo": "decryptData({@CIFRADO},{@CHAVE},\"AES/CBC/PKCS5Padding\",{@IV},false,true)",
    "variaveis": [
      {
        "key": "@CIFRADO",
        "value": "ITXYVXM2cwAeqmfBphe1Ow==",
        "type": "TEXTO"
      },
      {
        "key": "@CHAVE",
        "value": "0123456789abcdef",
        "type": "TEXTO"
      },
      {
        "key": "@IV",
        "value": "abcdef0123456789",
        "type": "TEXTO"
      }
    ],
    "runnable": true,
    "retorna": "texto",
    "combina": "inverso de cryptoData/encryptData; overload extra recebe lengthBlockKey(int). Puro (deterministico com chave+iv fixos); a saida (JSON/texto) costuma entrar em findJSON.",
    "cat": "cripto",
    "validado": true,
    "resultado": "cpf=12345678900"
  },
  "decryptDataShein": {
    "exemplo": "decryptDataShein({@CIFRADO_SHEIN},{@SHEIN_KEY})",
    "variaveis": [
      {
        "key": "@CIFRADO_SHEIN",
        "value": "k9aZ...==",
        "type": "TEXTO"
      },
      {
        "key": "@SHEIN_KEY",
        "value": "shein_secret_xxx",
        "type": "TEXTO"
      }
    ],
    "runnable": false,
    "retorna": "texto",
    "combina": "decripta payload Shein (AES/CBC/PKCS5, iv fixo space-station-default-iv, block 16); precisa da key da Shein. Saida normalmente e JSON -> findJSON2.",
    "cat": "cripto",
    "validado": false,
    "resultado": null
  },
  "sheinSignature": {
    "exemplo": "sheinSignature({@OPENKEYID},{@SECRETKEY},{@PATH},{@TS},{@RANDOMKEY})",
    "variaveis": [
      {
        "key": "@OPENKEYID",
        "value": "ABCDEF123",
        "type": "TEXTO"
      },
      {
        "key": "@SECRETKEY",
        "value": "shein_secret_xxx",
        "type": "TEXTO"
      },
      {
        "key": "@PATH",
        "value": "/open-api/goods/list",
        "type": "TEXTO"
      },
      {
        "key": "@TS",
        "value": "1717459200000",
        "type": "TEXTO"
      },
      {
        "key": "@RANDOMKEY",
        "value": "a1b2c",
        "type": "TEXTO"
      }
    ],
    "runnable": false,
    "retorna": "texto",
    "combina": "calcula assinatura Shein a partir de openKeyId+secretKey+path+timestamp+randomKey; precisa das credenciais Shein. Resultado vai no header x-lt-signature.",
    "cat": "cripto",
    "validado": false,
    "resultado": null
  },
  "getFullSheinHeader": {
    "exemplo": "getFullSheinHeader({@CODECOMPANY},\"/open-api/order/list\",{@RANDOMKEY})",
    "variaveis": [
      {
        "key": "@CODECOMPANY",
        "value": "12",
        "type": "TEXTO"
      },
      {
        "key": "@RANDOMKEY",
        "value": "a1b2c",
        "type": "TEXTO"
      }
    ],
    "runnable": false,
    "retorna": "json",
    "combina": "monta header Shein completo buscando credenciais do tenant em MKTPACTIVECOMPANIES por codeCompany (DB, multi-tenant); overload aceita fields=CHAVE1;CHAVE2. Saida JSON -> findJSON p/ extrair cada header.",
    "cat": "cripto",
    "validado": false,
    "resultado": null
  },
  "signShopee": {
    "exemplo": "signShopee({@CLIENTID},{@URL},{@KEY})",
    "variaveis": [
      {
        "key": "@CLIENTID",
        "value": "2008123",
        "type": "TEXTO"
      },
      {
        "key": "@URL",
        "value": "https://partner.shopeemobile.com/api/v2/order/get_order_list",
        "type": "TEXTO"
      },
      {
        "key": "@KEY",
        "value": "shopee_partner_key_xxx",
        "type": "TEXTO"
      }
    ],
    "runnable": false,
    "retorna": "texto",
    "combina": "assina request Shopee (overloads com partnerId/accessToken/clientid); precisa de partner_key/secret. Saida e o sign hex que vai na querystring/header.",
    "cat": "cripto",
    "validado": false,
    "resultado": null
  },
  "getFullShopeeParams": {
    "exemplo": "getFullShopeeParams({@CODECOMPANY},\"https://partner.shopeemobile.com/api/v2/order/get_order_list\")",
    "variaveis": [
      {
        "key": "@CODECOMPANY",
        "value": "12",
        "type": "TEXTO"
      }
    ],
    "runnable": false,
    "retorna": "texto",
    "combina": "calcula os parametros assinados de URL Shopee buscando credenciais do tenant por codeCompany (DB, multi-tenant). Concatene a saida na URL da chamada.",
    "cat": "cripto",
    "validado": false,
    "resultado": null
  },
  "signTikTok": {
    "exemplo": "signTikTok({@CODECOMPANY},{@URL},{@REQUESTBODY})",
    "variaveis": [
      {
        "key": "@CODECOMPANY",
        "value": "12",
        "type": "TEXTO"
      },
      {
        "key": "@URL",
        "value": "https://open-api.tiktokglobalshop.com/order/202309/orders?shop_id=7",
        "type": "TEXTO"
      },
      {
        "key": "@REQUESTBODY",
        "value": "{}",
        "type": "TEXTO"
      }
    ],
    "runnable": false,
    "retorna": "texto",
    "combina": "assina TikTok Shop lendo apiKey/secretKey do tenant (getActiveCompanies mktp 148, DB, multi-tenant) e a query da url. Saida vai no header/sign.",
    "cat": "cripto",
    "validado": false,
    "resultado": null
  },
  "signTemu": {
    "exemplo": "signTemu({@CODECOMPANY},{@REQUESTBODY},{@TS},\"JSON\")",
    "variaveis": [
      {
        "key": "@CODECOMPANY",
        "value": "12",
        "type": "TEXTO"
      },
      {
        "key": "@REQUESTBODY",
        "value": "{\"page\":1}",
        "type": "TEXTO"
      },
      {
        "key": "@TS",
        "value": "1717459200",
        "type": "TEXTO"
      }
    ],
    "runnable": false,
    "retorna": "texto",
    "combina": "assinatura Temu por tenant (le credenciais via getActiveCompanies, DB, multi-tenant); overload com dataType. Saida e o sign do request.",
    "cat": "cripto",
    "validado": false,
    "resultado": null
  },
  "temuBodyCrypted": {
    "exemplo": "temuBodyCrypted({@CODECOMPANY},{@REQUESTBODY},{@TS},\"JSON\")",
    "variaveis": [
      {
        "key": "@CODECOMPANY",
        "value": "12",
        "type": "TEXTO"
      },
      {
        "key": "@REQUESTBODY",
        "value": "{\"page\":1}",
        "type": "TEXTO"
      },
      {
        "key": "@TS",
        "value": "1717459200",
        "type": "TEXTO"
      }
    ],
    "runnable": false,
    "retorna": "json",
    "combina": "gera o body Temu ja assinado/criptografado por tenant (DB, multi-tenant); overload com dataType. Resultado e o payload pronto para POST.",
    "cat": "cripto",
    "validado": false,
    "resultado": null
  },
  "temuDecryptBody": {
    "exemplo": "temuDecryptBody({@CALLBACK},{@APPKEY},{@TS},{@SIGNATURE},{@EVENTCODE},{@EXTPARAM})",
    "variaveis": [
      {
        "key": "@CALLBACK",
        "value": "encrypted_payload_b64",
        "type": "TEXTO"
      },
      {
        "key": "@APPKEY",
        "value": "temu_app_key_xxx",
        "type": "TEXTO"
      },
      {
        "key": "@TS",
        "value": "1717459200",
        "type": "TEXTO"
      },
      {
        "key": "@SIGNATURE",
        "value": "abc123sig",
        "type": "TEXTO"
      },
      {
        "key": "@EVENTCODE",
        "value": "ORDER_STATUS_CHANGE",
        "type": "TEXTO"
      },
      {
        "key": "@EXTPARAM",
        "value": "",
        "type": "TEXTO"
      }
    ],
    "runnable": false,
    "retorna": "json",
    "combina": "descriptografa/valida o callback Temu (appKey+signature+eventCode); precisa das credenciais Temu. Saida JSON -> findJSON/findJSON2.",
    "cat": "cripto",
    "validado": false,
    "resultado": null
  },
  "basicAuthentication": {
    "exemplo": "basicAuthentication({@USER},{@SENHA})",
    "variaveis": [
      {
        "key": "@USER",
        "value": "integracao",
        "type": "TEXTO"
      },
      {
        "key": "@SENHA",
        "value": "s3nh4!",
        "type": "TEXTO"
      }
    ],
    "runnable": true,
    "retorna": "texto",
    "combina": "puro; devolve \"Basic <base64(user:senha)>\" (charset ISO-8859-1). Vai direto no header Authorization.",
    "cat": "cripto",
    "validado": true,
    "resultado": "Basic aW50ZWdyYWNhbzpzM25oNCE="
  },
  "bearerAuthentication": {
    "exemplo": "bearerAuthentication({@ACCESS_TOKEN})",
    "variaveis": [
      {
        "key": "@ACCESS_TOKEN",
        "value": "eyJhbGciOiJIUzI1NiJ9.payload.sig",
        "type": "TEXTO"
      }
    ],
    "runnable": true,
    "retorna": "texto",
    "combina": "puro; prefixa \"Bearer \" no token. Casa com findJSON do token e vai no header Authorization.",
    "cat": "cripto",
    "validado": true,
    "resultado": "Bearer eyJhbGciOiJIUzI1NiJ9.payload.sig"
  },
  "getAmazonHeader": {
    "exemplo": "getAmazonHeader(\"AWSAccessKeyId={@AK}\",\"SecretKey={@SK}\",\"url={@URL}\")",
    "variaveis": [
      {
        "key": "@AK",
        "value": "AKIAEXEMPLO",
        "type": "TEXTO"
      },
      {
        "key": "@SK",
        "value": "aws_secret_xxx",
        "type": "TEXTO"
      },
      {
        "key": "@URL",
        "value": "https://mws.amazonservices.com/Orders/2013-09-01",
        "type": "TEXTO"
      }
    ],
    "runnable": false,
    "retorna": "texto",
    "combina": "varargs de pares chave=valor; muta o authUtil ThreadLocal da Amazon (ordem importa entre as funcoes Amazon) e devolve header com assinatura. Precisa das chaves AWS/MWS.",
    "cat": "cripto",
    "validado": false,
    "resultado": null
  },
  "addAmazonHeaderAWS": {
    "exemplo": "addAmazonHeaderAWS(\"AWSAccessKeyId={@AK}\",\"SecretKey={@SK}\",\"url={@URL}\")",
    "variaveis": [
      {
        "key": "@AK",
        "value": "AKIAEXEMPLO",
        "type": "TEXTO"
      },
      {
        "key": "@SK",
        "value": "aws_secret_xxx",
        "type": "TEXTO"
      },
      {
        "key": "@URL",
        "value": "https://mws.amazonservices.com/",
        "type": "TEXTO"
      }
    ],
    "runnable": false,
    "retorna": "texto",
    "combina": "varargs chave=valor (exige exatamente chave=valor por arg); seta authUtil Amazon e retorna a URL de parametros do feed. Precisa de credenciais AWS; pareie com getAmazonSignatureAWS na mesma thread.",
    "cat": "cripto",
    "validado": false,
    "resultado": null
  },
  "getAmazonSignatureAWS": {
    "exemplo": "getAmazonSignatureAWS(\"AWSAccessKeyId={@AK}\",\"SecretKey={@SK}\",\"url={@URL}\")",
    "variaveis": [
      {
        "key": "@AK",
        "value": "AKIAEXEMPLO",
        "type": "TEXTO"
      },
      {
        "key": "@SK",
        "value": "aws_secret_xxx",
        "type": "TEXTO"
      },
      {
        "key": "@URL",
        "value": "https://mws.amazonservices.com/",
        "type": "TEXTO"
      }
    ],
    "runnable": false,
    "retorna": "texto",
    "combina": "varargs chave=valor; configura authUtil Amazon e devolve a chave/assinatura. Precisa das credenciais AWS; depende da ordem das chamadas Amazon na mesma thread (estado ThreadLocal).",
    "cat": "cripto",
    "validado": false,
    "resultado": null
  },
  "getAmazonContentSHA256": {
    "exemplo": "getAmazonContentSHA256()",
    "variaveis": [],
    "runnable": false,
    "retorna": "texto",
    "combina": "sem args; le o authUtil Amazon ThreadLocal ja configurado por uma chamada Amazon anterior na mesma thread. Devolve o hash do conteudo para header x-amz-content-sha256.",
    "cat": "cripto",
    "validado": false,
    "resultado": null
  },
  "getAliExpressSign": {
    "exemplo": "getAliExpressSign(\"app_key={@APPKEY}\",\"sign_method=sha256\",\"app_secret={@SECRET}\",\"method=aliexpress.solution.order.get\")",
    "variaveis": [
      {
        "key": "@APPKEY",
        "value": "503xxx",
        "type": "TEXTO"
      },
      {
        "key": "@SECRET",
        "value": "ali_app_secret_xxx",
        "type": "TEXTO"
      }
    ],
    "runnable": false,
    "retorna": "texto",
    "combina": "varargs chave=valor; assina o TOP request AliExpress (signTopRequest). Precisa de app_key/app_secret; a saida vai no parametro sign.",
    "cat": "cripto",
    "validado": false,
    "resultado": null
  },
  "decryptSankhyaData": {
    "exemplo": "decryptSankhyaData({@CODECOMPANY},{@ACESSO_CIFRADO})",
    "variaveis": [
      {
        "key": "@CODECOMPANY",
        "value": "12",
        "type": "TEXTO"
      },
      {
        "key": "@ACESSO_CIFRADO",
        "value": "enc:9f3a...",
        "type": "TEXTO"
      }
    ],
    "runnable": false,
    "retorna": "texto",
    "combina": "funcao custom; decripta acessos Sankhya por tenant (codeCompany, DB, multi-tenant). Saida e o dado claro para montar a integracao.",
    "cat": "cripto",
    "validado": false,
    "resultado": null
  },
  "encryptSankhyaData": {
    "exemplo": "encryptSankhyaData({@CODECOMPANY},{@ACESSO_CLARO})",
    "variaveis": [
      {
        "key": "@CODECOMPANY",
        "value": "12",
        "type": "TEXTO"
      },
      {
        "key": "@ACESSO_CLARO",
        "value": "user=adm;pwd=123",
        "type": "TEXTO"
      }
    ],
    "runnable": false,
    "retorna": "texto",
    "combina": "funcao custom; encripta acessos Sankhya por tenant (codeCompany, DB, multi-tenant). Par de decryptSankhyaData; saida e o token cifrado a persistir.",
    "cat": "cripto",
    "validado": false,
    "resultado": null
  },
  "urlShorter": {
    "exemplo": "urlShorter({@URL_RASTREIO},\"0\")",
    "variaveis": [
      {
        "key": "@URL_RASTREIO",
        "value": "https://rastreamento.correios.com.br/app/index.php?objeto=AB123456789BR",
        "type": "TEXTO"
      }
    ],
    "runnable": false,
    "retorna": "texto",
    "combina": "retorna a URL curta como texto puro, entra em qualquer arg de texto (ex.: dentro de concatenar2 pra montar mensagem); precisa de DB TemAPI gravado por tenant. codeCompany=\"0\" resolve via @CODECOMPANY do contexto.",
    "cat": "rede",
    "validado": false,
    "resultado": null
  },
  "tryConnection": {
    "exemplo": "tryConnection(\"https://mktp.oversystem.com.br\",\"https://13.65.139.59:8081;https://backup.temapi.com.br\",3000)",
    "variaveis": [],
    "runnable": false,
    "retorna": "texto",
    "combina": "retorna o host que respondeu (ou \"erro\"); use o retorno como base de URL nos requests seguintes ou em ifThenElse/dataSwitch pra escolher rota. Faz socket real (porta vem da URL; sem porta usa 80/HTTP, 443 caso contrario), entao depende de rede.",
    "cat": "rede",
    "validado": false,
    "resultado": null
  },
  "getHost": {
    "exemplo": "getHost(\"https://mktp.oversystem.com.br/MKTPlace2/rest/JsonBrokerServices/save\")",
    "variaveis": [],
    "runnable": true,
    "retorna": "texto",
    "combina": "puro: so faz parse de URI e devolve o host (ex.: mktp.oversystem.com.br); aninha bem como entrada de tryConnection ou em qualquer arg de texto. Retorna null se a URL for invalida.",
    "cat": "rede",
    "validado": true,
    "resultado": "mktp.oversystem.com.br"
  },
  "getLineWhere": {
    "exemplo": "getLineWhere({@EDI},\"1\",\"2\",\"34\")",
    "variaveis": [
      {
        "key": "@EDI",
        "value": "10ABC0001\n34XYZ0002\n34QWE0003",
        "type": "TEXTO"
      }
    ],
    "runnable": true,
    "retorna": "texto",
    "combina": "varre texto multilinha e devolve a 1a linha cujo trecho posIni..posFin == where (1-based: posIni>=1); encadeia com getLineValue/extract pra ler campos da linha achada",
    "cat": "outros",
    "validado": true,
    "resultado": "34XYZ0002"
  },
  "getLineValue": {
    "exemplo": "getLineValue({@LINHA},\"11\",\"19\",\"2\")",
    "variaveis": [
      {
        "key": "@LINHA",
        "value": "34XYZ0002 000012345",
        "type": "TEXTO"
      }
    ],
    "runnable": true,
    "retorna": "numero",
    "combina": "fatia o trecho posIni..posFin da linha (1-based: posIni>=1) e divide por 10^nroDec (valor com casas implicitas); use depois de getLineWhere pra extrair o valor da linha selecionada",
    "cat": "outros",
    "validado": true,
    "resultado": "123.45"
  },
  "findEDI": {
    "exemplo": "findEDI({@EDI},\"1\",\"2\",\"34\",\"11\",\"19\",\"2\")",
    "variaveis": [
      {
        "key": "@EDI",
        "value": "10ABC0001 000000000\n34XYZ0002 000012345",
        "type": "TEXTO"
      }
    ],
    "runnable": true,
    "retorna": "numero",
    "combina": "combina getLineWhere+getLineValue num passo: acha a linha (where no trecho posIni..posFin, 1-based) e le o valor em posIniData..posFinData com nroDec casas; ideal pra parse de arquivos EDI posicionais",
    "cat": "outros",
    "validado": true,
    "resultado": "123.45"
  },
  "toByte": {
    "exemplo": "toByte({@CONTEUDO})",
    "variaveis": [
      {
        "key": "@CONTEUDO",
        "value": "conteudo a enviar",
        "type": "TEXTO"
      }
    ],
    "runnable": true,
    "retorna": "binario",
    "combina": "converte String em byte[] (getBytes default); serve de entrada pra encodeByteBase64/convertPdfToZpl ou pra corpo binario de request",
    "cat": "outros",
    "validado": true,
    "resultado": [
      99,
      111,
      110,
      116,
      101,
      117,
      100,
      111,
      32,
      97,
      32,
      101,
      110,
      118,
      105,
      97,
      114
    ]
  },
  "getArrayValue": {
    "exemplo": "getArrayValue({@MAPA},\"0\")",
    "variaveis": [],
    "runnable": false,
    "retorna": "objeto",
    "combina": "le o elemento de indice i num HashMap em memoria; precisa de um mapa numerico ja criado por outra funcao/passo do fluxo no contexto (nao aceita string literal solta)",
    "cat": "outros",
    "validado": false,
    "resultado": null
  },
  "getNextUid": {
    "exemplo": "getNextUid(\"\")",
    "variaveis": [],
    "runnable": true,
    "retorna": "texto",
    "combina": "gera UUID v4 aleatorio (ignora o arg); use pra idempotency-key/correlation-id em header ou body de request",
    "cat": "outros",
    "validado": false,
    "resultado": null
  },
  "translateOracle": {
    "exemplo": "translateOracle(\"Sao Jose da Agua\")",
    "variaveis": [],
    "runnable": true,
    "retorna": "texto",
    "combina": "remove acentos e aplica UPPERCASE numa tacada; bom pra normalizar texto antes de comparar/gravar em coluna case-insensitive",
    "cat": "outros",
    "validado": true,
    "resultado": "SAO JOSE DA AGUA"
  },
  "addCacheVariable": {
    "exemplo": "addCacheVariable(\"@TOKEN\",{@ACCESS_TOKEN})",
    "variaveis": [
      {
        "key": "@ACCESS_TOKEN",
        "value": "eyJhbGciOiJIUzI1NiJ9...",
        "type": "TEXTO"
      }
    ],
    "runnable": false,
    "retorna": "objeto",
    "combina": "grava valor no globalMap (cache da thread/fluxo) pra reusar em passos seguintes; precisa rodar dentro do runtime de fluxo TemAPI, depois leia com getCacheVariable",
    "cat": "outros",
    "validado": false,
    "resultado": null
  },
  "getCacheVariable": {
    "exemplo": "getCacheVariable(\"@TOKEN\",\"@TOKEN\")",
    "variaveis": [],
    "runnable": false,
    "retorna": "objeto",
    "combina": "le do globalMap a chave (o valor lido e o 2o arg); par de addCacheVariable; so faz sentido dentro do fluxo onde a variavel foi cacheada",
    "cat": "outros",
    "validado": false,
    "resultado": null
  },
  "getTemporaryFile": {
    "exemplo": "getTemporaryFile(\"etiqueta-12345.pdf\",true)",
    "variaveis": [],
    "runnable": false,
    "retorna": "binario",
    "combina": "le arquivo do diretorio temporario da TemAPI; base64=true devolve string pronta pra body; precisa que o arquivo ja exista no tmp do servidor",
    "cat": "outros",
    "validado": false,
    "resultado": null
  },
  "convertPdfToZpl": {
    "exemplo": "convertPdfToZpl({@PDF_BYTES},203)",
    "variaveis": [],
    "runnable": false,
    "retorna": "binario",
    "combina": "renderiza o PDF (byte[]) e gera ZPL pra impressora termica; dpi tipico 203/300, overload com pdfPage limita a 1 pagina; entrada vem de toByte/decodeBase64Byte/getTemporaryFile",
    "cat": "outros",
    "validado": false,
    "resultado": null
  },
  "getMapValue": {
    "exemplo": "getMapValue({@DADOS},\"valor\")",
    "variaveis": [],
    "runnable": false,
    "retorna": "objeto",
    "combina": "busca chave num HashMap/LinkedHashMap em memoria (retorna \"0\" se ausente); precisa de um mapa ja montado por passo anterior do fluxo, nao de string literal",
    "cat": "outros",
    "validado": false,
    "resultado": null
  },
  "righString": {
    "exemplo": "righString({@CODBARRAS},6)",
    "variaveis": [
      {
        "key": "@CODBARRAS",
        "value": "7891234567890",
        "type": "TEXTO"
      }
    ],
    "runnable": true,
    "retorna": "texto",
    "combina": "pega os ultimos len caracteres (null-safe); par do leftString, encaixa em qualquer arg de texto",
    "cat": "outros",
    "validado": true,
    "resultado": "567890"
  },
  "enviarEmail": {
    "exemplo": "enviarEmail(\"cliente@exemplo.com\",\"no-reply@temapi.com.br\",\"Pedido confirmado\",{@CORPO_HTML})",
    "variaveis": [
      {
        "key": "@CORPO_HTML",
        "value": "<p>Seu pedido foi confirmado.</p>",
        "type": "TEXTO"
      }
    ],
    "runnable": false,
    "retorna": "texto",
    "combina": "dispara email via EmailService e retorna \"Enviado\" ou a msg de erro; efeito colateral, precisa do SMTP configurado no servidor",
    "cat": "outros",
    "validado": false,
    "resultado": null
  },
  "generateRandomKey": {
    "exemplo": "generateRandomKey(\"NANO\",false)",
    "variaveis": [],
    "runnable": true,
    "retorna": "texto",
    "combina": "gera valor randomico por tipo (String/Number/Nano); isGuid=true em String devolve GUID; use pra nonce/randomKey de assinatura (sheinSignature, getFullSheinHeader) ou idempotency",
    "cat": "outros",
    "validado": false,
    "resultado": null
  },
  "getHtmlAtributeValue": {
    "exemplo": "getHtmlAtributeValue({@HTML},\"a\",\"href\")",
    "variaveis": [
      {
        "key": "@HTML",
        "value": "<html><body><a href=\"https://rastreio.exemplo.com/AB123\">rastrear</a></body></html>",
        "type": "TEXTO"
      }
    ],
    "runnable": true,
    "retorna": "texto",
    "combina": "parseia HTML (Jsoup) e devolve o atributo do 1o elemento com a tag dada; bom pra raspar link/valor de resposta HTML, complementa html2text",
    "cat": "outros",
    "validado": true,
    "resultado": "https://rastreio.exemplo.com/AB123"
  },
  "addAmazonParameters": {
    "exemplo": "addAmazonParameters(\"MarketplaceId=A2Q3Y263D00KWC\",\"CreatedAfter={@DATA_INI}\")",
    "variaveis": [
      {
        "key": "@DATA_INI",
        "value": "2026-06-01T00:00:00Z",
        "type": "TEXTO"
      }
    ],
    "runnable": false,
    "retorna": "texto",
    "combina": "monta a query string canonica (cada arg chave=valor) pra request SP-API; alimenta getRequestDataAmazon/getAmazonSignatureAWS; exige formato chave=valor em cada item",
    "cat": "outros",
    "validado": false,
    "resultado": null
  },
  "buscaEtiqueta": {
    "exemplo": "buscaEtiqueta(\"SEDEX\",{@CODECOMPANY})",
    "variaveis": [],
    "runnable": false,
    "retorna": "texto",
    "combina": "pede o proximo codigo de etiqueta dos Correios (CorreiosImpl.getNextEtq) pro servico/empresa; precisa de contrato Correios configurado no tenant (codeCompany)",
    "cat": "outros",
    "validado": false,
    "resultado": null
  },
  "gerarEFecharPLP": {
    "exemplo": "gerarEFecharPLP(\"SEDEX\",{@CODECOMPANY})",
    "variaveis": [],
    "runnable": false,
    "retorna": "xml",
    "combina": "gera e fecha a PLP dos Correios numa chamada; efeito colateral remoto, precisa de credencial Correios do tenant; sequencia tipica: buscaEtiqueta, gerarPLP, gerarEFecharPLP",
    "cat": "outros",
    "validado": false,
    "resultado": null
  },
  "getSankhyaData": {
    "exemplo": "getSankhyaData(\"https://erp.cliente.com.br/mge/service.sbr\",\"SELECT NOMEPARC FROM TGFPAR WHERE CODPARC = 1\")",
    "variaveis": [],
    "runnable": false,
    "retorna": "json",
    "combina": "roda SQL no Sankhya via finderGenericSQL (usa @CODECOMPANY do contexto pra credencial); retorna JSON, encaixa em findJSON/findJSON2; precisa de URL+login Sankhya do tenant",
    "cat": "outros",
    "validado": false,
    "resultado": null
  },
  "gerarPLP": {
    "exemplo": "gerarPLP(\"SEDEX\",{@CODECOMPANY})",
    "variaveis": [],
    "runnable": false,
    "retorna": "xml",
    "combina": "abre a PLP dos Correios pro servico/empresa (CorreiosImpl.gerarPLP); precisa de contrato Correios no tenant; antecede gerarEFecharPLP",
    "cat": "outros",
    "validado": false,
    "resultado": null
  },
  "getRequestData": {
    "exemplo": "getRequestData(\"meuServico\",\"BASE\",\"\",\"POST\",{@BODY},\"Content-Type=application/json\",\"1\")",
    "variaveis": [
      {
        "key": "@BODY",
        "value": "{\"sku\":\"ABC-123\",\"qty\":5}",
        "type": "JSON"
      }
    ],
    "runnable": false,
    "retorna": "json",
    "combina": "request HTTP generico JSON (serviceName,urlType,params,method,body,header,codeMktp) via ProcessamentoItens/MarketPlaceUtil; retorna JSON pra findJSON/stringify; precisa de servico/endpoint+credencial configurados no tenant",
    "cat": "outros",
    "validado": false,
    "resultado": null
  },
  "printEtiqueta": {
    "exemplo": "printEtiqueta(\"AB123456789BR\",{@CODECOMPANY},\"PDF\")",
    "variaveis": [],
    "runnable": false,
    "retorna": "binario",
    "combina": "gera a etiqueta dos Correios pelo codigo de rastreio (tipo PDF/ZPL); precisa de contrato Correios do tenant; saida PDF pode entrar em convertPdfToZpl",
    "cat": "outros",
    "validado": false,
    "resultado": null
  },
  "buscaCep": {
    "exemplo": "buscaCep(\"01310100\",\"localidade\")",
    "variaveis": [],
    "runnable": false,
    "retorna": "texto",
    "combina": "consulta CEP nos Correios e devolve o campo pedido (logradouro/bairro/localidade/uf); overload de 4 args nao gera erro e devolve stringOnError; depende de servico externo dos Correios",
    "cat": "outros",
    "validado": false,
    "resultado": null
  },
  "getRequestDataAmazon": {
    "exemplo": "getRequestDataAmazon({@URL_SPAPI},\"GET\",\"\",true,true,\"sellingpartnerapi::notifications\")",
    "variaveis": [
      {
        "key": "@URL_SPAPI",
        "value": "https://sellingpartnerapi-na.amazon.com/orders/v0/orders?MarketplaceIds=ATVPDKIKX0DER",
        "type": "TEXTO"
      }
    ],
    "runnable": false,
    "retorna": "json",
    "combina": "request a SP-API Amazon PII: assina SigV4 e (generateLWA=true) gera o token LWA; retorna JSON pra findJSON; precisa de chaves AWS/LWA e config Amazon do tenant",
    "cat": "outros",
    "validado": false,
    "resultado": null
  },
  "getSankhyaDataView": {
    "exemplo": "getSankhyaDataView(\"https://erp.cliente.com.br/mge/service.sbr\",{@BODY_VIEW})",
    "variaveis": [
      {
        "key": "@BODY_VIEW",
        "value": "{\"serviceName\":\"CRUDServiceProvider.loadView\",\"requestBody\":{\"query\":{\"viewName\":\"VGF_PEDIDOS\"}}}",
        "type": "JSON"
      }
    ],
    "runnable": false,
    "retorna": "json",
    "combina": "carrega uma VIEW do Sankhya via CRUDServiceProvider.loadView (usa @CODECOMPANY pra credencial); retorna JSON pra findJSON/toSankhyaJSON; precisa de URL+login Sankhya do tenant",
    "cat": "outros",
    "validado": false,
    "resultado": null
  }
}